import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA,  } from '@angular/material/dialog';
import { ResidentModel } from '@shared/models/data/resident-model';
import { CredentialModel } from '@shared/models/data/credential-model';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { RosterService } from '@shared/services/roster.service';
import { SessionService } from '@shared/services/session.service';

@Component({
  selector: 'aaos-app-edit-resident',
  templateUrl: './edit-resident.component.html',
  styleUrls: ['./edit-resident.component.scss']
})
export class EditResidentComponent implements OnInit {

  formGroup: FormGroup;
  firstNameControl = 'firstName';
  lastNameControl = 'lastName';
  emailControl = 'email';
  confirmEmailControl = 'confirmEmail';
  noninstitutionalEmailControl = 'noninstitutionalEmail';
  startDateControl = 'startDate';
  endDateControl = 'endDate';
  credentialCodeControl = 'credentialCode';
  npiNumberControl = 'npi';
  editPrivileges = false;
  resident: ResidentModel;
  defaultStartDate: Date;
  defaultEndDate: Date;
  errors: Array<string>;
  loading = false;
  pgy: number;
  currentDate: Date;
  startDateReasons: string[];
  endDateReasons: string[];
  credentialList: Array<CredentialModel>;

  constructor(public dialogRef: MatDialogRef<EditResidentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResidentModel,
    private enrollmentService: EnrollmentService,
    private rosterService: RosterService,
    private sessionService: SessionService
    ) {
      dialogRef.addPanelClass('double-column-dialog');
    }

    ngOnInit(): void {
      this.createFormGroup();

      this.credentialList = new Array<CredentialModel>();
      this.credentialList.push({ credentialCode: '21', credentialDescription: 'Allopathic'});
      this.credentialList.push({ credentialCode: '22', credentialDescription: 'Osteopathic'});
      this.enrollmentService.getCurrentDate(this.sessionService.getMcid())
      .subscribe(x => {
        this.currentDate = new Date(x.currentDate);
        this.currentDate = new Date(this.currentDate.getUTCFullYear(), this.currentDate.getUTCMonth(), this.currentDate.getUTCDate());
        this.updatePGY();
        this.validateDates();
      });

    }

    public closeDialog() {
      this.dialogRef.close();
    }

    updatePGY() {
      this.pgy = this.rosterService.getPGY(new Date(this.currentDate), new Date(this.formGroup.controls[this.endDateControl].value) );
    }

    invalidRequiredField(fieldName: string): boolean {
      if (this.formGroup.get(fieldName).hasError('required')) {
        return true;
      }
      return false;
    }

    createFormGroup() {
      this.formGroup = new FormGroup({
        firstName: new FormControl({value: this.data.firstName, disabled: true}),
        lastName: new FormControl({value: this.data.lastName, disabled: true}),
        email: new FormControl({value: this.data.institutionalEmailAddress, disabled: true}),
        noninstitutionalEmail: new FormControl({value: this.data.nonInstitutionalEmailAddress, disabled: true}),
        startDate: new FormControl({value: this.data.residencyBeginDate, disabled: true}),
        endDate: new FormControl({value: this.data.residencyEndDate, disabled: true}),
        credentialCode: new FormControl({value: this.data.credentialCode, disabled: !this.data.canEditCredentialCode}),
        npi: new FormControl({value: this.data.npi, disabled: false})
      });

      this.formGroup.controls['credentialCode'].setValidators([Validators.required]);
      this.formGroup.controls['email'].setValidators([Validators.required, Validators.email]);
    }

    validateDates() {
        this.startDateReasons = this.rosterService.isValidStartDate(new Date(
          this.formGroup.controls[this.startDateControl].value),
          new Date(this.formGroup.controls[this.endDateControl].value));
        this.endDateReasons = this.rosterService.isValidEndDate(new Date(
          this.formGroup.controls[this.startDateControl].value),
          new Date(this.formGroup.controls[this.endDateControl].value));
    }

    isFormValid(): boolean {
        return this.startDateReasons?.length === 0 && this.endDateReasons?.length === 0
          && !this.formGroup.controls[this.credentialCodeControl].invalid;
    }

    onSubmit() {
      this.loading = true;
      this.data.residencyBeginDate = this.formGroup.controls[this.startDateControl].value;
      this.data.residencyEndDate = this.formGroup.controls[this.endDateControl].value;
      this.data.credentialCode = this.formGroup.controls[this.credentialCodeControl].value;
      this.data.npi = this.formGroup.controls[this.npiNumberControl].value?.toString();

      this.enrollmentService.saveResident(this.data).subscribe(results => {
        // Clear errors
        this.errors = new Array<string>();
        this.loading = false;
        if (results.isValid) {
          this.dialogRef.close();
        } else {
          this.errors = results.errors;
        }
      });
    }
}
